"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedError = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const HttpError_1 = require("./HttpError");
class UnauthorizedError extends HttpError_1.HttpError {
    constructor(error, statusCode = 403, message = 'unauthorized') {
        super(statusCode, message, error);
    }
}
tslib_1.__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 403, description: 'HTTP Code' }),
    tslib_1.__metadata("design:type", Number)
], UnauthorizedError.prototype, "statusCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ defaultValue: 'unauthorized', description: 'HTTP Status' }),
    tslib_1.__metadata("design:type", String)
], UnauthorizedError.prototype, "code", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({
        example: 'Not authorized to connect to backend',
        description: 'Describing what is unauthorized',
    }),
    tslib_1.__metadata("design:type", String)
], UnauthorizedError.prototype, "message", void 0);
exports.UnauthorizedError = UnauthorizedError;
